import React, { Component } from "react";
import PropTypes from "prop-types";
import VolumeSeries from "./VolumeSeries";
import StraightLine from "./StraightLine";

class MADeviationSeries extends Component {
  render() {
    const {
      yAccessor,
      increasingColor,
      decreasingColor,
      strokeZeroLine,
      className,
      ...rest
    } = this.props;

    // Transform yAccessor to return format expected by VolumeSeries
    const volumeAccessor = (d) => {
      const maDevData = yAccessor(d);
      if (!maDevData) return undefined;

      // VolumeSeries expects { volume, direction }
      return {
        volume: maDevData.value,
        direction: maDevData.direction,
      };
    };

    // Create fill function that uses direction from data
    const fill = ({ direction }) => {
      return direction === "up" ? increasingColor : decreasingColor;
    };

    return (
      <g className={className}>
        <VolumeSeries
          {...rest}
          yAccessor={volumeAccessor}
          fill={fill}
          baseAt={(xScale, yScale) => yScale(0)}
        />
        <StraightLine yValue={0} stroke={strokeZeroLine} />
      </g>
    );
  }
}

MADeviationSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  increasingColor: PropTypes.string.isRequired,
  decreasingColor: PropTypes.string.isRequired,
  strokeZeroLine: PropTypes.object,
  className: PropTypes.string,
  clip: PropTypes.bool,
  onContextMenu: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

MADeviationSeries.defaultProps = {
  increasingColor: "#00DD00",
  decreasingColor: "#FF0000",
  strokeZeroLine: { color: "#666666", dash: "Solid", width: 1, opacity: 1 },
  className: "react-stockcharts-ma-deviation",
  clip: true,
};

export default MADeviationSeries;
